module.exports = __webpack_public_path__ + "img/CybersecurityAwarenessCurriculum2023.de12377b.jpg";